var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.13 0H6.32C2.82956 0 0 2.82956 0 6.32V15.13C0 18.6204 2.82956 21.45 6.32 21.45H15.13C18.6204 21.45 21.45 18.6204 21.45 15.13V6.32C21.45 2.82956 18.6204 0 15.13 0Z",
    fill: "url(#paint0_linear_1_318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1312 5.9502C11.6212 5.9502 11.2012 6.3702 11.2012 6.8802C11.2012 7.3902 11.6212 7.8102 12.1312 7.8102C12.6412 7.8102 13.0612 7.3902 13.0612 6.8802C13.0612 6.3702 12.6412 5.9502 12.1312 5.9502ZM12.4412 7.3402C12.3912 7.3902 12.3312 7.4302 12.2612 7.4502V7.6402H12.0012V7.4702C11.9112 7.4602 11.8312 7.4302 11.7812 7.3902L11.7312 7.3602L11.8212 7.1002L11.9012 7.1502C11.9612 7.1902 12.0312 7.2102 12.1012 7.2102C12.1612 7.2102 12.2212 7.1802 12.2212 7.1202C12.2212 7.0902 12.2112 7.0502 12.0812 6.9902C11.9212 6.9302 11.7612 6.8402 11.7612 6.6302C11.7612 6.4802 11.8612 6.3502 12.0112 6.3002V6.1102H12.2712V6.2802C12.3412 6.2902 12.3912 6.3102 12.4512 6.3402L12.5112 6.3702L12.4112 6.6302L12.3312 6.5902C12.3312 6.5902 12.2512 6.5402 12.1612 6.5402C12.1012 6.5402 12.0612 6.5602 12.0612 6.6102C12.0612 6.6402 12.0712 6.6702 12.2212 6.7302C12.4312 6.8202 12.5312 6.9302 12.5312 7.1102C12.5312 7.2002 12.5012 7.2802 12.4412 7.3402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11 6.13984V4.83984H9.1L7.25 6.72984L8.51 6.73984C8.84 6.73984 9.11 6.46984 9.11 6.13984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25023 6.99961V10.8096L7.74023 11.0896V7.48961H8.51023C9.26023 7.48961 9.86023 6.87961 9.86023 6.13961V5.32961H13.1202C13.1202 5.32961 13.1402 5.32961 13.1502 5.32961C13.4702 5.34961 13.7202 5.60961 13.7202 5.92961V11.0896L14.2102 10.8096V5.92961C14.2102 5.34961 13.7602 4.87961 13.1802 4.84961C13.1602 4.84961 13.1402 4.84961 13.1202 4.84961H9.37023V6.14961C9.37023 6.62961 8.98023 7.01961 8.50023 7.01961H7.24023L7.25023 6.99961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9698 10.2197H8.44984C8.38984 10.2197 8.33984 10.2697 8.33984 10.3297V10.4297C8.33984 10.4297 8.35984 10.4997 8.38984 10.5197C8.40984 10.5297 8.42984 10.5397 8.44984 10.5397H12.9698C13.0298 10.5397 13.0798 10.4897 13.0798 10.4297V10.3297C13.0798 10.2697 13.0298 10.2197 12.9698 10.2197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1111 9.4098C13.1111 9.3498 13.0611 9.2998 13.0011 9.2998H8.48109C8.42109 9.2998 8.37109 9.3498 8.37109 9.4098V9.5098C8.37109 9.5098 8.39109 9.5798 8.42109 9.5998C8.44109 9.6098 8.46109 9.6198 8.48109 9.6198H13.0011C13.0611 9.6198 13.1111 9.5698 13.1111 9.5098V9.4098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1111 8.48988C13.1111 8.42988 13.0611 8.37988 13.0011 8.37988H8.48109C8.42109 8.37988 8.37109 8.42988 8.37109 8.48988V8.58988C8.37109 8.58988 8.39109 8.65988 8.42109 8.67988C8.44109 8.68988 8.46109 8.69988 8.48109 8.69988H13.0011C13.0611 8.69988 13.1111 8.64988 13.1111 8.58988V8.48988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5008 9.76953V10.9795L10.7108 13.1595L6.95078 10.9795V9.76953C6.15078 9.95953 5.55078 10.6795 5.55078 11.5395V14.7895C5.55078 15.7895 6.37078 16.6095 7.37078 16.6095H14.0808C15.0808 16.6095 15.9008 15.7895 15.9008 14.7895V11.5395C15.9008 10.6795 15.3008 9.95953 14.5008 9.76953ZM15.3108 14.7995C15.3108 15.4795 14.7608 16.0295 14.0808 16.0295H7.37078C6.69078 16.0295 6.14078 15.4795 6.14078 14.7995V11.5495C6.14078 11.4495 6.15078 11.3495 6.18078 11.2495L10.7108 13.8795L15.2708 11.2495C15.2908 11.3495 15.3108 11.4495 15.3108 11.5495V14.7995Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_318",
    x1: -19.95,
    y1: -8.39,
    x2: 39.03,
    y2: 28.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.45,
    height: 21.45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.9552d48f08742b8dab582ba017870144.svg";
export { ForwardRef as ReactComponent };